import React from 'react';
import { Helmet } from 'react-helmet';
import { Categories } from 'src/components';

const CategoriesPage = () => (
  <>
    <Helmet>
      <title> Restaurant Dashboard</title>
    </Helmet>

    <Categories />
  </>
);

export default CategoriesPage;
